import React from "react";
import DagonetStatus from "./DagonetStatus.jsx";
import { BOTS, BOT_OPTIONS } from "./dagonetBots.mjs";

export default function DagonetHeader({ bot, active, onBotChange }) {
  const selectedBot = BOTS[bot] || BOTS.dagonet;

  return (
    <header className="dagonet-header">
      <div className="header-content">
        <h1>
          <a href={selectedBot.profileUrl} target="_blank" rel="noopener noreferrer">
            {selectedBot.name}
          </a>
        </h1>
        <p className="tagline">Manifold trading bot</p>
      </div>
      <div className="header-actions">
        <div className="bot-toggle" role="group" aria-label="Trading bot">
          {BOT_OPTIONS.map(option => (
            <button
              key={option.key}
              type="button"
              className={option.key === selectedBot.key ? 'is-active' : ''}
              aria-pressed={option.key === selectedBot.key}
              onClick={() => onBotChange(option.key)}
            >
              {option.name}
            </button>
          ))}
        </div>
        <DagonetStatus active={active} />
      </div>
    </header>
  );
}
